import http from "./httpVideo";
import { BaseResponseType } from "@/types/message";

const { get, post } = http;

//当前登录用户是否已关注此用户
export const currentUserIsFollow = (followeeId:any):Promise<BaseResponseType>=>{
  return get(`/community-api/community/personal/currentUserIsFollow?followeeId=${followeeId}`)
}

// 获取我的问题列表
export const getQuestionUserList=(params:any):Promise<BaseResponseType>=>{
  return post(`/community-api/community/personal/user/questions`, params)
}

// 取消收藏
export const cancelCollect = (sourceId: string, type: 'UGC' | 'FAQ' | 'NOTICE') :Promise<BaseResponseType>=> {
  return http.delete(`/community-api/community/personal/favorite?sourceId=${sourceId}&type=${type}`);
}

// 获取我的关注列表
export const getMyFollowList=(params:any):Promise<BaseResponseType>=>{
  return get(`/community-api/community/personal/follow/list`, {params})
}

// 获取我的收藏列表
export const getMyCollectList=(params:any):Promise<BaseResponseType>=>{
  return get(`/community-api/community/personal/favorite/list`, {params})
}

// 看过的问题列表
export const getViewQuestions=(params:any):Promise<BaseResponseType>=>{
  return get(`/community-api/community/personal/browse/question/list`, {params})
}

// 看过的视频列表
export const getViewVideos=(params:any):Promise<BaseResponseType>=>{
  return get(`/community-api/community/personal/browse/video/list`, {params})
}

// 关注用户
export const followUser=(followeeId:string):Promise<BaseResponseType>=>{
  return get(`/community-api/community/personal/follow?followeeId=${followeeId}`)
}

// 取消关注
export const cancelFollow = (followeeId:string) :Promise<BaseResponseType>=> {
  return http.delete(`/community-api/community/personal/unfollow?followeeId=${followeeId}`);
}

// 删除单条浏览记录
export const deleteSignleRecord = (sourceId:string) :Promise<BaseResponseType>=> {
  return http.delete(`/community-api/community/personal/browse?sourceId=${sourceId}`);
}

// 获取用户资料
export const getUserInfo = (userId:string):Promise<BaseResponseType>=>{
  return get(`/community-api/community/user/profile/${userId}`)
}

// 获取用户问题列表
export const getUserCreateQuestions = (params: any):Promise<BaseResponseType>=>{
  return get(`/community-api/community/user/questions`, { params })
}